import {
	CHAT_GET_CONTACTS,
	CHAT_CHANGE_CONVERSATION,
	CHAT_GET_CONVERSATIONS,
	CHAT_DELETE_MESSAGE,
	USER_FROM_REQUESTS,
	SET_MESSAGES_COUNT,
	SET_CHATS_COUNT,
	SET_CHATS_Filter,
	SET_COMPLAINTS_COUNT


} from '../actions';

const INIT_STATE = {
	allContacts: [],
	selectedUser: null,
	messages: {}
};

function removeDuplicatesAndKeepLatest(array, key) {
	const uniqueObject = {};
	array.forEach((item) => {
		const itemKey = item[key];
		uniqueObject[itemKey] = item;
	});
	const uniqueArray = Object.values(uniqueObject);
	return uniqueArray;
}

const ApplyFilter = ({ state, data }) => {
	let { unread, labelIds } = data
	let newState = {
		contactsList: state?.allContacts
	}
	if (unread) {
		newState.contactsList = newState.contactsList?.filter(r => (r.newCount && r.newCount !== 0))
	}
	// Filter by labels if selected (backup filter in case Firestore query doesn't catch it)
	if (labelIds && labelIds.length > 0) {
		newState.contactsList = newState.contactsList?.filter(r => {
			if (!r.labels || r.labels.length === 0) return false;
			// Check if chat has at least one of the selected labels
			return labelIds.some(labelId => r.labels.includes(labelId));
		})
	}

	return newState
}

const ex = (state = INIT_STATE, action) => {
	switch (action.type) {

		case CHAT_GET_CONTACTS:
			let { contactsList: list } = ApplyFilter({ state: { ...state, allContacts: removeDuplicatesAndKeepLatest([...state.allContacts, ...action.payload], 'wa_id') }, data: state?.chatsFilter || {}, })

			return { ...state, allContacts: list };
		case CHAT_GET_CONVERSATIONS:
			return {
				...state, messages: {
					...state.messages,
					[action?.payload?.parent_id]: {
						...state.messages[action?.payload?.parent_id],
						[action?.payload?.id]: action?.payload,
					}
				}
			};
		case CHAT_DELETE_MESSAGE:
			let messages = state.messages[action?.payload?.parent_id]
			delete messages[action?.payload?.id]
			return {
				...state, messages: {
					...state.messages,
					[action?.payload?.parent_id]: messages
				}
			};
		case CHAT_CHANGE_CONVERSATION:
			return { ...state, selectedUser: action.payload };
		case SET_MESSAGES_COUNT:
			return { ...state, newMessagesCount: action.payload };
		case SET_CHATS_COUNT:
			return { ...state, newChatsCount: action.payload };
		case SET_COMPLAINTS_COUNT:
			return { ...state, openComplaintsCount: action.payload };
		case SET_CHATS_Filter:
			return { ...state, chatsFilter: action.payload, allContacts: [] };
		case USER_FROM_REQUESTS:
			return { ...state, userFromRequests: action.payload };

		default: return { ...state };
	}
}
export default ex;